/** Query flag used by production smoke tests and deliberate internal QA sessions. */
export const ANALYTICS_QA_PARAM = "ownly_qa";

/** Keep browser automation and explicitly marked QA out of the commercial funnel. */
export function isAnalyticsQaUrl(rawUrl: string): boolean {
  try {
    const url = new URL(rawUrl, "https://www.ownlydigital.co.uk");
    return url.searchParams.has(ANALYTICS_QA_PARAM);
  } catch {
    return false;
  }
}

export function shouldSuppressAnalytics(input: {
  eventUrl: string;
  webdriver: boolean;
  qaSession: boolean;
}): boolean {
  return input.webdriver || input.qaSession || isAnalyticsQaUrl(input.eventUrl);
}

/**
 * Query keys that can carry a person's details, and must never reach analytics.
 *
 * Emails link to `/book?name=…&email=…` so nobody retypes their own details (see
 * `bookingHrefWith` in lib/booking.ts), and Vercel Analytics records the full address of every
 * page view. Without this, every emailed booking link put a name and an email address into the
 * analytics dashboard. Removed rather than masked: the page view still counts, it just carries
 * nothing about who it was.
 */
/* `t` is the manage-link token on /book/manage: whoever holds it can move or cancel that booking. */
const PERSONAL_QUERY_KEYS = ["name", "email", "phone", "note", "a1", "a2", "t"] as const;

export function redactAnalyticsUrl(rawUrl: string): string {
  try {
    const url = new URL(rawUrl);
    let changed = false;
    for (const key of PERSONAL_QUERY_KEYS) {
      if (url.searchParams.has(key)) {
        url.searchParams.delete(key);
        changed = true;
      }
    }
    return changed ? url.toString() : rawUrl;
  } catch {
    return rawUrl;
  }
}
